import { render } from "./Home.vue?vue&type=template&id=368e8f36&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=368e8f36&scoped=true&lang=css"

import exportComponent from "D:\\Coding\\welikethespeech\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368e8f36"]])

export default __exports__